// import { RichTextElement } from '@kontent-ai/react-components';
import React from 'react';
import RichTextBody from './RichTextComponents';
import CustomModal from './CustomModal';
import DOMPurify from 'dompurify';
// import e from 'express';
// import { useIntl } from 'react-intl';

const DigitalAssetImageBorder: React.FC<{ element: any }> = ({ element }) => {
  //   const { formatMessage } = useIntl();
  const [show, setShow] = React.useState(false);
  const handleClose = (): void => setShow(false);

  const [modalPosition, setModalPosition] = React.useState<{
    top: number;
    left: number;
  } | null>(null);

  const handleImageClick = (event: React.MouseEvent<HTMLImageElement>) => {
    // Use viewport coordinates without adding scroll offset
    const pos = {
      top: event.clientY, // Just use viewport Y position
      left: event.clientX, // Just use viewport X position
    };
    setModalPosition(pos);
    setShow(true);
  };

  // Utility function to check if rich text contains meaningful content
  const hasMeaningfulText = (richText: any): boolean => {
    if (!richText?.value) return false; // Check if value exists
    const strippedText = DOMPurify.sanitize(richText.value, {
      ALLOWED_TAGS: [],
      ALLOWED_ATTR: [],
    }).trim(); // Remove all HTML tags and trim whitespace
    return strippedText.length > 0; // Return true if content has any non-empty text
  };

  return (
    <>
      {/* Render the modal conditionally */}
      {show && (
        <CustomModal
          show={true}
          onHide={handleClose}
          element={element}
          position={modalPosition}
        />
      )}

      {/* Main content */}
      <div>
        <div className="col-md-2"></div>
        <div>
          <div></div>
          <div className="da-panel-primary">
            <div className="da-title">{element.title.value}</div>
            <div className="toolbox-panel-body screenboxtext">
              {element.image_asset.value.length > 0 && (
                <>
                  <div className="hidden-xs hidden-sm">
                    <img
                      src={element.image_asset.value[0].url}
                      data-target="#modal-N100DF"
                      data-toggle="modal"
                      alt={element.image_asset.value[0].description}
                      className="img-responsive center-block"
                      onClick={handleImageClick}
                    />
                  </div>
                  <div className="visible-xs-block visible-sm-block">
                    <img
                      src={element.image_asset.value[0].url}
                      alt={element.image_asset.value[0].description || 'image'}
                      className="img-responsive center-block"
                      onClick={handleImageClick}
                    />
                  </div>
                </>
              )}

              {hasMeaningfulText(element.paragraph) && (
                <div
                  className="toolbox-panel-body"
                  style={{ marginBottom: '0' }}
                >
                  <RichTextBody element={element.paragraph} />
                </div>
              )}
              <div
                className="da-footer"
                style={{ marginTop: '0', paddingLeft: '0.5em' }}
              >
                <span className="daid" style={{ textAlign: 'left' }}>
                  {hasMeaningfulText(element.image_permission_language) &&
                    DOMPurify.sanitize(
                      element.image_permission_language?.value,
                      {
                        ALLOWED_TAGS: [],
                        ALLOWED_ATTR: [],
                      },
                    ).trim()}
                  {element.digital_asset_id?.value &&
                    ` [${element.digital_asset_id?.value}]`}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DigitalAssetImageBorder;
